import { render, staticRenderFns } from "./NsfwEntryGate.vue?vue&type=template&id=0e8da5d6&scoped=true&"
import script from "./NsfwEntryGate.vue?vue&type=script&lang=ts&"
export * from "./NsfwEntryGate.vue?vue&type=script&lang=ts&"
import style0 from "./NsfwEntryGate.vue?vue&type=style&index=0&id=0e8da5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8da5d6",
  null
  
)

export default component.exports